import { useCurrentLanguage } from "../i18n.hooks"
import { CheckCircledIcon } from "@radix-ui/react-icons"
import { CircleIcon } from "@radix-ui/react-icons"
import { useTranslation } from "react-i18next"

export const MapMenuSwitchButton: React.FC<{ link: string }> = ({ link }) => {
  const { t } = useTranslation()
  const [language, updateQueryLanguage] = useCurrentLanguage()

  const activeLanguage = language === link
  return (
    <div className="y flex items-center gap-x-2 p-2">
      {activeLanguage ? (
        <CheckCircledIcon className={`text-brand-green`} />
      ) : (
        <CircleIcon className={`text-brand-green`} />
      )}
      <button
        className="text-brand-green-dark decoration-[#f9c793] decoration-4 underline-offset-8 hover:underline"
        type="button"
        onClick={() => {
          updateQueryLanguage(link)
        }}
      >
        {t(`common:${link}`)}
      </button>
    </div>
  )
}
